import React from 'react';

import { Badge, BadgeProps } from '@meterup/atto';
import { Quote } from '@meterup/connect-api';
import { Quote_Availability } from '@meterup/connect-api/src/connectProtos';

type ServiceabilityBadgeProps = {
  quote: Quote;
  size?: BadgeProps['size'];
  ends?: BadgeProps['ends'];
};

function ServiceabilityBadge({ quote, size, ends }: ServiceabilityBadgeProps) {
  if (quote.availability && quote.availability !== Quote_Availability.unknown) {
    if (quote.availability === Quote_Availability.location_on_net) {
      return (
        <Badge size={size} variant="positive" ends={ends}>
          Onsite
        </Badge>
      );
    }
    if (quote.availability === Quote_Availability.location_near_net) {
      return (
        <Badge size={size} variant="neutral" ends={ends}>
          Nearby
        </Badge>
      );
    }
  }
  return null;
}

export default ServiceabilityBadge;
